import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { ButtonComponent } from "../../../../elements/button/button.component";

@Component({
  selector: "app-position-controller",
  templateUrl: "./position-controller.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./position-controller.component.scss"],
  imports: [ButtonComponent]
})
export class PositionControllerComponent implements OnInit {
  @Input() isAtHistoryEnd: boolean;
  @Input() isAtHistoryBeginning: boolean;

  @Output() previousPos: EventEmitter<void> = new EventEmitter<void>();
  @Output() nextPos: EventEmitter<void> = new EventEmitter<void>();
  @Output() firstPos: EventEmitter<void> = new EventEmitter<void>();
  @Output() lastPos: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
